export const CHANGE_ORDER_TASKS_LOAD_SUCCESS =
  'CHANGE_ORDER_TASKS_LOAD_SUCCESS';
export const CHANGE_ORDER_TASKS_SHOW_MODAL_SET =
  'CHANGE_ORDER_TASKS_SHOW_MODAL_SET';
export const CHANGE_ORDER_TASKS_ADD = 'CHANGE_ORDER_TASKS_ADD';
export const CHANGE_ORDER_TASKS_UPDATE = 'CHANGE_ORDER_TASKS_UPDATE';
export const CHANGE_ORDER_TASK_DELETE = 'CHANGE_ORDER_TASK_DELETE';



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-tasks/store/action-types.js